// This is the replacement for `borerOperatorChangePushModifier` in `src/rxdb/BorerOperatorChangeFeed/queryBuilder.ts`
import { BorerOperatorChange } from '../../BorerOperatorChangeFeed/queryBuilder';
import { PushModifier } from '../replicate';

export const pushModifier: PushModifier<BorerOperatorChange> = doc => {
  // Another local property - if we toggle one of the states to failed,
  // don't send a change request to BE
  if (doc.failedSync || doc.showInSchedulerView === false) return null;
  return doc;
};
